import { createContext } from "react";

const BI_WS0025Context = createContext();

export { BI_WS0025Context };